export enum AccrualSummaryFilterEnums {
  CURRENT = 0,
  PAST = 1,
  ALL = 2,
}
